<div class="table-container">
  <app-new-table
    [additionalFilters]="{ id: id }"
    [dataSource]="dataSource"
    [displayedColumns]="displayedColumns"
    [initialSort]="{
      active: 'id',
      direction: 'desc'
    }"
  ></app-new-table>
</div>
